import { Injectable } from '@angular/core';
import { BalanceStore } from './balance.store';
import { tap } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { AccountModel } from '../models/account.model';
import { MemberQuery } from '../member/member.query';
import { config } from '../../shared/config';

@Injectable({ providedIn: 'root' })
export class BalanceService {
  constructor(private balanceStore: BalanceStore, private api: ApiService, private memberQuery: MemberQuery) {}
  /** will return current member balance if memberId is null */
  fetchBalance(purse: number, memberId?: string) {
    memberId = memberId || this.memberQuery.getUserContext().memberId;
    let id = [memberId, purse].join('-');

    const useExternalRefBalance = config.useExternalRefBalance ?? false;

    return this.api
      .getAnySingle<AccountModel>(`purse/balance/${purse}?accountBalance=${useExternalRefBalance}`)
      .pipe(
        tap((acc) =>
          this.balanceStore.upsert(id, { purseId: purse, memberId: memberId || '', balance: acc.TotalBalanceAllowedToSpend })
        )
      );
  }

  debitBalance(purse: number, amount: number, memberId?: string) {
    if (amount < 0) {
      throw new Error('cannot debit a negative amount');
    }
    memberId = memberId || this.memberQuery.getUserContext().memberId;
    let id = [memberId, purse].join('-');
    this.balanceStore.update(id, (b) => {
      return { balance: b.balance - amount };
    });
  }

  addBalance(purse: number, amount: number, memberId?: string) {
    if (amount < 0) {
      throw new Error('cannot add a negative amount');
    }
    memberId = memberId || this.memberQuery.getUserContext().memberId;
    let id = [memberId, purse].join('-');
    this.balanceStore.update(id, (b) => {
      return { balance: b.balance + amount };
    });
  }
}
